import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { provide } from 'vue'
import * as echarts from 'echarts'

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

provide('echarts', echarts)


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})